import { createAction, props } from '@ngrx/store';

import {
  CountItemInToteExportCriteria,
  DestroyTransactionExportCriteria,
  MaterialRequestTransactionExportCriteria,
  ProductTagExportCriteria,
  ReduceToClearSummaryExportCriteria,
  SalesPerformanceExportCriteria,
  SalesTransactionExportCriteria,
  ShiftRecordExportCriteria,
  StoreExpenseExportCriteria,
  StoreOtherIncomeExportCriteria
} from '../../models';
import { CafeStockExportCriteria } from '../../models/stock/cafe-stock.model';

export interface SubmitMyReportResponse {
  id: string;
  version: number;
  requestNo: string;
  reportName: string;
  jobId: string;
  type: string;
  createdBy: string;
  requestedDate: Date;
  status: string;
}

export const reportAction = {
  clearAllStates: createAction('[Report] Clear States'),
  exportReportFileResponse: createAction(
    '[Report] Export Report File Response',
    props<{ isSuccess: boolean; response: any; fileName: string }>()
  ),
  exportMyReportResponse: createAction(
    '[Report] Export My Report Response',
    props<{ isSuccess: boolean; response: SubmitMyReportResponse }>()
  ),
  exportReportFileError: createAction(
    '[Report] Export Report File Error',
    props<{ isSuccess: boolean; error: any }>()
  ),
  salesPerformance: createAction('[Report] Sales Performance', props<{ payload: SalesPerformanceExportCriteria }>()),
  salesTransaction: createAction('[Report] Sales Transaction', props<{ payload: SalesTransactionExportCriteria }>()),
  shiftRecord: createAction('[Report] Shift Record', props<{ payload: ShiftRecordExportCriteria }>()),
  countItemInTote: createAction('[Report] Count Item In Tote', props<{ payload: CountItemInToteExportCriteria }>()),
  storeOtherIncome: createAction('[Report] Store Other Income', props<{ payload: StoreOtherIncomeExportCriteria }>()),
  materialRequestTransaction: createAction(
    '[Report] Material Request Transaction',
    props<{ payload: MaterialRequestTransactionExportCriteria }>()
  ),
  reduceToClearSummary: createAction(
    '[Report] Reduce To Clear Summary',
    props<{ payload: ReduceToClearSummaryExportCriteria }>()
  ),
  destroyTransaction: createAction(
    '[Report] Destroy Transaction',
    props<{ payload: DestroyTransactionExportCriteria }>()
  ),
  storeExpense: createAction('[Report] Store Expense', props<{ payload: StoreExpenseExportCriteria }>()),
  reprintRecallPackedItems: createAction('[Report] Reprint Recall Packed Items'),
  reprintRecallReturnReceipt: createAction('[Report] Reprint Recall Return Receipt'),
  setPdfReport: createAction('[Report] Pdf Report', props<{ payload: any }>()),
  clearPdfReportItems: createAction('[Report] Clear Pdf Report Items'),
  cafeStock: createAction('[Report] Stock Cafe', props<{ payload: CafeStockExportCriteria }>()),
  productTag: createAction('[Report] Product Tag', props<{ payload: ProductTagExportCriteria }>())
};
